import { INodeWithPath } from "../../../../../interface/interfaces";

export const getAllParents = (filteredAllRobotsFullNode: INodeWithPath[], allNodes: INodeWithPath[]): INodeWithPath[] => {
    const parents: INodeWithPath[] = [];

    const findParent = (node: INodeWithPath): INodeWithPath | undefined => {
        return allNodes.find((parent) => parent.Id === node.Parent);
    };

    filteredAllRobotsFullNode.forEach((node) => {
        let currentNode = node;

        while (currentNode) {
            const parentNode = findParent(currentNode);

            if (parentNode) {
                if(!parents.includes(parentNode)){
                    parents.push(parentNode);
                }
                currentNode = parentNode;
            } else {
                break;
            }
        }
    });


    return parents;
};
